import * as React from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { cn } from 'src/lib/utils'
import { Button } from './button'

const PasswordInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & {
    showToggle?: boolean
  }
>(({ className, showToggle = true, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev)
  }

  return (
    <div className="relative">
      <input
        type={showPassword ? 'text' : 'password'}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          showToggle && 'pr-10',
          className,
        )}
        ref={ref}
        {...props}
      />
      {showToggle && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
          onClick={togglePasswordVisibility}
          disabled={props.disabled}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? (
            <Eye className="h-4 w-4 text-black" />
          ) : (
            <EyeOff className="h-4 w-4 text-black" />
          )}
        </Button>
      )}
    </div>
  )
})

PasswordInput.displayName = 'PasswordInput'

export { PasswordInput }
